"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _d3Scale = require("d3-scale");

var _Frame = _interopRequireDefault(require("./Frame"));

var _TooltipPositioner = _interopRequireDefault(require("./TooltipPositioner"));

var _xyframeRules = require("./annotationRules/xyframeRules");

var _baseRules = require("./annotationRules/baseRules");

var _lineDrawing = require("./svg/lineDrawing");

var _frameFunctions = require("./svg/frameFunctions");

var _coordinateNames = require("./constants/coordinateNames");

var _unflowedFunctions = require("./data/unflowedFunctions");

var _diffing = require("./processing/diffing");

var _multiAccessorUtils = require("./data/multiAccessorUtils");

var _xyDrawing = require("./processing/xyDrawing");

var _frame_props = require("./constants/frame_props");

var _SpanOrDiv = require("./SpanOrDiv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var xyframeKey = "";
var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

for (var i = 32; i > 0; --i) {
  xyframeKey += chars[Math.floor(Math.random() * chars.length)];
}

var projectedCoordinateNames = {
  y: _coordinateNames.projectedY,
  x: _coordinateNames.projectedX,
  yMiddle: _coordinateNames.projectedYMiddle,
  yTop: _coordinateNames.projectedYTop,
  yBottom: _coordinateNames.projectedYBottom,
  xMiddle: _coordinateNames.projectedXMiddle,
  xTop: _coordinateNames.projectedXTop,
  xBottom: _coordinateNames.projectedXBottom
};

var XYFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(XYFrame, _React$Component);

  function XYFrame(props) {
    var _this;

    _classCallCheck(this, XYFrame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(XYFrame).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "defaultXYSVGRule", function (_ref) {
      var baseD = _ref.d,
          i = _ref.i,
          annotationLayer = _ref.annotationLayer,
          lines = _ref.lines,
          summaries = _ref.summaries,
          points = _ref.points;
      var _this$props = _this.props,
          showLinePoints = _this$props.showLinePoints,
          defined = _this$props.defined,
          baseMargin = _this$props.margin,
          size = _this$props.size,
          svgAnnotationRules = _this$props.svgAnnotationRules;
      var _this$state = _this.state,
          xyFrameRender = _this$state.xyFrameRender,
          xScale = _this$state.xScale,
          yScale = _this$state.yScale,
          xAccessor = _this$state.xAccessor,
          yAccessor = _this$state.yAccessor,
          axesData = _this$state.axesData,
          annotatedSettings = _this$state.annotatedSettings;
      var screenCoordinates = [];
      var idAccessor = annotatedSettings.lineIDAccessor;

      if (baseD.type === "highlight") {
        return (0, _xyframeRules.svgHighlight)({
          d: baseD,
          i: i,
          idAccessor: idAccessor,
          lines: lines,
          summaries: summaries,
          points: points,
          xScale: xScale,
          yScale: yScale,
          xyFrameRender: xyFrameRender,
          defined: defined
        });
      }

      var d = baseD.coordinates ? baseD : (0, _lineDrawing.findPointByID)({
        point: baseD,
        idAccessor: idAccessor,
        lines: lines,
        xScale: xScale,
        projectedX: _coordinateNames.projectedX,
        xAccessor: xAccessor
      });
      if (!d) return null;
      var margin = (0, _frameFunctions.calculateMargin)({
        margin: baseMargin,
        axes: axesData,
        title: annotatedSettings.title,
        size: size
      });

      var _adjustedPositionSize = (0, _frameFunctions.adjustedPositionSize)({
        size: size,
        margin: margin
      }),
          adjustedPosition = _adjustedPositionSize.adjustedPosition,
          adjustedSize = _adjustedPositionSize.adjustedSize;

      if (!d.coordinates && !d.bounds) {
        screenCoordinates = [(0, _lineDrawing.relativeX)({
          point: d,
          projectedXMiddle: _coordinateNames.projectedXMiddle,
          projectedX: _coordinateNames.projectedX,
          xAccessor: xAccessor,
          xScale: xScale
        }) || 0, (0, _lineDrawing.relativeY)({
          point: d,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          yAccessor: yAccessor,
          yScale: yScale,
          showLinePoints: showLinePoints
        }) || 0];
      } else if (!d.bounds) {
        screenCoordinates = d.coordinates.reduce(function (coords, p) {
          var xCoordinate = (0, _lineDrawing.relativeX)({
            point: p,
            projectedXMiddle: _coordinateNames.projectedXMiddle,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor,
            xScale: xScale
          });
          var yCoordinate = (0, _lineDrawing.relativeY)({
            point: p,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            yAccessor: yAccessor,
            yScale: yScale
          });

          if (Array.isArray(yCoordinate)) {
            return [].concat(_toConsumableArray(coords), [[xCoordinate, Math.min.apply(Math, _toConsumableArray(yCoordinate))], [xCoordinate, Math.max.apply(Math, _toConsumableArray(yCoordinate))]]);
          } else if (Array.isArray(xCoordinate)) {
            return [].concat(_toConsumableArray(coords), [[Math.min.apply(Math, _toConsumableArray(xCoordinate)), yCoordinate], [Math.max.apply(Math, _toConsumableArray(xCoordinate)), yCoordinate]]);
          } else {
            return [].concat(_toConsumableArray(coords), [[xCoordinate, yCoordinate]]);
          }
        }, []);
      }

      var voronoiHover = annotationLayer.voronoiHover;
      var customSVG = svgAnnotationRules && svgAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: _this.props,
        xyFrameState: _this.state,
        summaries: summaries,
        points: points,
        lines: lines,
        voronoiHover: voronoiHover,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer
      });

      if (svgAnnotationRules !== undefined && customSVG !== null) {
        return customSVG;
      } else if (d.type === "desaturation-layer") {
        return (0, _baseRules.desaturationLayer)({
          style: d.style instanceof Function ? d.style(d, i) : d.style,
          size: adjustedSize,
          i: i,
          key: d.key
        });
      } else if (d.type === "xy" || d.type === "frame-hover") {
        return (0, _xyframeRules.svgXYAnnotation)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates
        });
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _xyframeRules.basicReactAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i
        });
      } else if (d.type === "enclose") {
        return (0, _xyframeRules.svgEncloseAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i
        });
      } else if (d.type === "enclose-rect") {
        return (0, _xyframeRules.svgRectEncloseAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i
        });
      } else if (d.type === "enclose-hull") {
        return (0, _xyframeRules.svgHullEncloseAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i
        });
      } else if (d.type === "x") {
        return (0, _xyframeRules.svgXAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          adjustedSize: adjustedSize
        });
      } else if (d.type === "y") {
        return (0, _xyframeRules.svgYAnnotation)({
          d: d,
          screenCoordinates: screenCoordinates,
          i: i,
          adjustedSize: adjustedSize,
          adjustedPosition: adjustedPosition
        });
      } else if (d.type === "bounds") {
        return (0, _xyframeRules.svgBoundsAnnotation)({
          d: d,
          i: i,
          adjustedSize: adjustedSize,
          xAccessor: xAccessor,
          yAccessor: yAccessor,
          xScale: xScale,
          yScale: yScale
        });
      } else if (d.type === "line") {
        return (0, _xyframeRules.svgLineAnnotation)({
          d: d,
          i: i,
          screenCoordinates: screenCoordinates
        });
      } else if (d.type === "area") {
        return (0, _xyframeRules.svgAreaAnnotation)({
          d: d,
          i: i,
          xScale: xScale,
          xAccessor: xAccessor,
          yScale: yScale,
          yAccessor: yAccessor,
          annotationLayer: annotationLayer
        });
      } else if (d.type === "horizontal-points") {
        return (0, _xyframeRules.svgHorizontalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      } else if (d.type === "vertical-points") {
        return (0, _xyframeRules.svgVerticalPointsAnnotation)({
          d: d,
          lines: lines.data,
          points: points.data,
          xScale: xScale,
          yScale: yScale,
          pointStyle: points.styleFn
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "defaultXYHTMLRule", function (_ref2) {
      var baseD = _ref2.d,
          i = _ref2.i,
          lines = _ref2.lines,
          summaries = _ref2.summaries,
          points = _ref2.points,
          annotationLayer = _ref2.annotationLayer;
      var _this$state2 = _this.state,
          xAccessor = _this$state2.xAccessor,
          yAccessor = _this$state2.yAccessor,
          xScale = _this$state2.xScale,
          yScale = _this$state2.yScale,
          SpanOrDiv = _this$state2.SpanOrDiv,
          annotatedSettings = _this$state2.annotatedSettings,
          axesData = _this$state2.axesData;
      var voronoiHover = annotationLayer.voronoiHover;
      var screenCoordinates = [];
      var _this$props2 = _this.props,
          useSpans = _this$props2.useSpans,
          tooltipContent = _this$props2.tooltipContent,
          optimizeCustomTooltipPosition = _this$props2.optimizeCustomTooltipPosition,
          htmlAnnotationRules = _this$props2.htmlAnnotationRules,
          size = _this$props2.size,
          showLinePoints = _this$props2.showLinePoints,
          baseMargin = _this$props2.margin;
      var idAccessor = annotatedSettings.lineIDAccessor;
      var d = (0, _lineDrawing.findPointByID)({
        point: baseD,
        idAccessor: idAccessor,
        lines: lines,
        xScale: xScale,
        projectedX: _coordinateNames.projectedX,
        xAccessor: xAccessor
      });

      if (!d) {
        return null;
      }

      var xCoord = d[_coordinateNames.projectedXMiddle] || d[_coordinateNames.projectedX] || (0, _multiAccessorUtils.findFirstAccessorValue)(xAccessor, d);
      var yCoord = d[_coordinateNames.projectedYMiddle] || d[_coordinateNames.projectedY] || (0, _multiAccessorUtils.findFirstAccessorValue)(yAccessor, d);
      var xString = xCoord && xCoord.toString ? xCoord.toString() : xCoord;
      var yString = yCoord && yCoord.toString ? yCoord.toString() : yCoord;
      var margin = (0, _frameFunctions.calculateMargin)({
        margin: baseMargin,
        axes: axesData,
        title: annotatedSettings.title,
        size: size
      });

      var _adjustedPositionSize2 = (0, _frameFunctions.adjustedPositionSize)({
        size: size,
        margin: margin
      }),
          adjustedPosition = _adjustedPositionSize2.adjustedPosition,
          adjustedSize = _adjustedPositionSize2.adjustedSize;

      if (!d.coordinates) {
        screenCoordinates = [xScale(xCoord) || 0, (0, _lineDrawing.relativeY)({
          point: d,
          projectedYMiddle: _coordinateNames.projectedYMiddle,
          projectedY: _coordinateNames.projectedY,
          showLinePoints: showLinePoints,
          yAccessor: yAccessor,
          yScale: yScale
        }) || 0];
      } else {
        screenCoordinates = d.coordinates.map(function (p) {
          var foundP = (0, _lineDrawing.findPointByID)({
            point: _objectSpread({
              x: 0,
              y: 0
            }, p),
            idAccessor: idAccessor,
            lines: lines,
            xScale: xScale,
            projectedX: _coordinateNames.projectedX,
            xAccessor: xAccessor
          });
          return [(xScale((0, _multiAccessorUtils.findFirstAccessorValue)(xAccessor, d)) || 0) + adjustedPosition[0], ((0, _lineDrawing.relativeY)({
            point: foundP,
            projectedYMiddle: _coordinateNames.projectedYMiddle,
            projectedY: _coordinateNames.projectedY,
            yAccessor: yAccessor,
            yScale: yScale
          }) || 0) + adjustedPosition[1]];
        });
      }

      var customAnnotation = htmlAnnotationRules && htmlAnnotationRules({
        d: d,
        i: i,
        screenCoordinates: screenCoordinates,
        xScale: xScale,
        yScale: yScale,
        xAccessor: xAccessor,
        yAccessor: yAccessor,
        xyFrameProps: _this.props,
        xyFrameState: _this.state,
        summaries: summaries,
        points: points,
        lines: lines,
        voronoiHover: voronoiHover,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        annotationLayer: annotationLayer
      });

      if (htmlAnnotationRules && customAnnotation !== null) {
        return customAnnotation;
      }

      if (d.type === "frame-hover") {
        var content = React.createElement(SpanOrDiv, {
          span: useSpans,
          className: "tooltip-content"
        }, React.createElement("p", {
          key: "html-annotation-content-1"
        }, xString), React.createElement("p", {
          key: "html-annotation-content-2"
        }, yString), d.percent ? React.createElement("p", {
          key: "html-annotation-content-3"
        }, Math.floor(d.percent * 1000) / 10, "%") : null);

        if (d.type === "frame-hover" && tooltipContent) {
          content = optimizeCustomTooltipPosition ? React.createElement(_TooltipPositioner.default, {
            tooltipContent: tooltipContent,
            tooltipContentArgs: d
          }) : tooltipContent(d);
        }

        return (0, _xyframeRules.htmlTooltipAnnotation)({
          content: content,
          screenCoordinates: screenCoordinates,
          i: i,
          d: d,
          useSpans: useSpans
        });
      }

      return null;
    });

    Object.keys(props).forEach(function (d) {
      if (!_frame_props.xyframeproptypes[d]) {
        if (_frame_props.ordinalframeproptypes[d]) {
          console.error("".concat(d, " is an OrdinalFrame prop are you sure you're using the right frame?"));
        } else if (_frame_props.networkframeproptypes[d]) {
          console.error("".concat(d, " is a NetworkFrame prop are you sure you're using the right frame?"));
        } else {
          console.error("".concat(d, " is not a valid XYFrame prop"));
        }
      }
    });
    var baseState = {
      SpanOrDiv: (0, _SpanOrDiv.HOCSpanOrDiv)(props.useSpans),
      size: [500, 500],
      dataVersion: undefined,
      lineData: undefined,
      pointData: undefined,
      summaryData: undefined,
      projectedLines: undefined,
      projectedPoints: undefined,
      projectedSummaries: undefined,
      fullDataset: [],
      adjustedPosition: [0, 0],
      adjustedSize: [500, 500],
      backgroundGraphics: null,
      foregroundGraphics: null,
      axesData: undefined,
      axes: undefined,
      axesTickLines: undefined,
      renderNumber: 0,
      margin: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      calculatedXExtent: [0, 0],
      calculatedYExtent: [0, 0],
      xAccessor: [function (d) {
        return d.x;
      }],
      yAccessor: [function (d) {
        return d.y;
      }],
      xExtent: [0, 0],
      yExtent: [0, 0],
      areaAnnotations: [],
      xScale: (0, _d3Scale.scaleLinear)(),
      yScale: (0, _d3Scale.scaleLinear)(),
      title: null,
      legendSettings: undefined,
      xyFrameRender: {},
      canvasDrawing: [],
      annotatedSettings: {
        xAccessor: undefined,
        yAccessor: undefined,
        summaryDataAccessor: undefined,
        lineDataAccessor: undefined,
        renderKeyFn: undefined,
        lineType: undefined,
        summaryType: undefined,
        lineIDAccessor: undefined,
        summaries: undefined,
        lines: undefined,
        title: undefined,
        xExtent: undefined,
        yExtent: undefined
      },
      overlay: undefined,
      props: props
    };
    _this.state = _objectSpread({}, baseState, (0, _xyDrawing.calculateXYFrame)(props, baseState, true));
    return _this;
  }

  _createClass(XYFrame, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;

      if (onUnmount) {
        onUnmount(this.props, this.state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          size = _this$props3.size,
          className = _this$props3.className,
          annotationSettings = _this$props3.annotationSettings,
          annotations = _this$props3.annotations,
          additionalDefs = _this$props3.additionalDefs,
          hoverAnnotation = _this$props3.hoverAnnotation,
          interaction = _this$props3.interaction,
          customClickBehavior = _this$props3.customClickBehavior,
          customHoverBehavior = _this$props3.customHoverBehavior,
          customDoubleClickBehavior = _this$props3.customDoubleClickBehavior,
          canvasPostProcess = _this$props3.canvasPostProcess,
          baseMarkProps = _this$props3.baseMarkProps,
          useSpans = _this$props3.useSpans,
          canvasSummaries = _this$props3.canvasSummaries,
          canvasPoints = _this$props3.canvasPoints,
          canvasLines = _this$props3.canvasLines,
          afterElements = _this$props3.afterElements,
          beforeElements = _this$props3.beforeElements,
          renderOrder = _this$props3.renderOrder,
          matte = _this$props3.matte,
          frameKey = _this$props3.frameKey,
          showLinePoints = _this$props3.showLinePoints,
          sketchyRenderingEngine = _this$props3.sketchyRenderingEngine,
          disableContext = _this$props3.disableContext,
          frameRenderOrder = _this$props3.frameRenderOrder,
          disableCanvasInteraction = _this$props3.disableCanvasInteraction,
          interactionSettings = _this$props3.interactionSettings;
      var _this$state3 = this.state,
          backgroundGraphics = _this$state3.backgroundGraphics,
          foregroundGraphics = _this$state3.foregroundGraphics,
          adjustedPosition = _this$state3.adjustedPosition,
          adjustedSize = _this$state3.adjustedSize,
          margin = _this$state3.margin,
          axes = _this$state3.axes,
          axesTickLines = _this$state3.axesTickLines,
          xScale = _this$state3.xScale,
          yScale = _this$state3.yScale,
          fullDataset = _this$state3.fullDataset,
          dataVersion = _this$state3.dataVersion,
          areaAnnotations = _this$state3.areaAnnotations,
          legendSettings = _this$state3.legendSettings,
          xyFrameRender = _this$state3.xyFrameRender,
          annotatedSettings = _this$state3.annotatedSettings,
          overlay = _this$state3.overlay;
      return React.createElement(_Frame.default, {
        name: "xyframe",
        renderPipeline: xyFrameRender,
        adjustedPosition: adjustedPosition,
        size: size,
        projectedCoordinateNames: projectedCoordinateNames,
        xScale: xScale,
        yScale: yScale,
        axes: axes,
        axesTickLines: axesTickLines,
        title: annotatedSettings.title,
        dataVersion: dataVersion,
        matte: matte,
        className: className,
        adjustedSize: adjustedSize,
        frameKey: frameKey || xyframeKey,
        additionalDefs: additionalDefs,
        hoverAnnotation: hoverAnnotation,
        defaultSVGRule: this.defaultXYSVGRule,
        defaultHTMLRule: this.defaultXYHTMLRule,
        annotations: areaAnnotations.length > 0 ? [].concat(_toConsumableArray(annotations), _toConsumableArray(areaAnnotations)) : annotations,
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        projectedYMiddle: _coordinateNames.projectedYMiddle,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: fullDataset,
        showLinePoints: typeof showLinePoints === "string" ? showLinePoints : undefined,
        margin: margin,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        disableContext: disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: useSpans,
        canvasRendering: !!(canvasSummaries || canvasPoints || canvasLines),
        renderOrder: renderOrder,
        overlay: overlay,
        sketchyRenderingEngine: sketchyRenderingEngine,
        frameRenderOrder: frameRenderOrder,
        disableCanvasInteraction: disableCanvasInteraction,
        interactionSettings: interactionSettings
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var props = prevState.props;
      var _prevState$xExtent = prevState.xExtent,
          oldXExtent = _prevState$xExtent === void 0 ? [] : _prevState$xExtent,
          _prevState$yExtent = prevState.yExtent,
          oldYExtent = _prevState$yExtent === void 0 ? [] : _prevState$yExtent,
          oldSize = prevState.size,
          oldDataVersion = prevState.dataVersion,
          lineData = prevState.lineData,
          summaryData = prevState.summaryData,
          pointData = prevState.pointData;
      var baseNewXExtent = nextProps.xExtent,
          baseNewYExtent = nextProps.yExtent,
          newSize = nextProps.size,
          newDataVersion = nextProps.dataVersion,
          newLines = nextProps.lines,
          newSummaries = nextProps.summaries,
          newPoints = nextProps.points;
      var newXExtent = (0, _unflowedFunctions.extentValue)(baseNewXExtent);
      var newYExtent = (0, _unflowedFunctions.extentValue)(baseNewYExtent);
      var extentChange = oldXExtent[0] !== newXExtent[0] && newXExtent[0] !== undefined || oldYExtent[0] !== newYExtent[0] && newYExtent[0] !== undefined || oldXExtent[1] !== newXExtent[1] && newXExtent[1] !== undefined || oldYExtent[1] !== newYExtent[1] && newYExtent[1] !== undefined;
      var lineChange = (0, _diffing.basicDataChangeCheck)(lineData, newLines);
      var summaryChange = (0, _diffing.basicDataChangeCheck)(summaryData, newSummaries);
      var pointChange = (0, _diffing.basicDataChangeCheck)(pointData, newPoints);

      if (oldDataVersion && oldDataVersion !== newDataVersion || !prevState.fullDataset) {
        return (0, _xyDrawing.calculateXYFrame)(nextProps, prevState, true);
      } else if (lineChange || summaryChange || pointChange || oldSize[0] !== newSize[0] || oldSize[1] !== newSize[1] || extentChange || !oldDataVersion && _frame_props.xyFrameChangeProps.find(function (d) {
        return props[d] !== nextProps[d];
      })) {
        var dataChanged = lineChange || summaryChange || pointChange || extentChange || !!_frame_props.xyFrameDataProps.find(function (d) {
          return (0, _diffing.basicPropDiffing)(props[d], nextProps[d]);
        });
        return (0, _xyDrawing.calculateXYFrame)(nextProps, prevState, dataChanged);
      }

      return null;
    }
  }]);

  return XYFrame;
}(React.Component);

_defineProperty(XYFrame, "defaultProps", {
  annotations: [],
  foregroundGraphics: undefined,
  size: [500, 500],
  className: "",
  lineType: "line",
  name: "xyframe",
  dataVersion: undefined
});

_defineProperty(XYFrame, "displayName", "XYFrame");

var _default = XYFrame;
exports.default = _default;
module.exports = exports.default;